import { Injectable } from '@angular/core';
import { Firestore, doc, docData } from '@angular/fire/firestore';
import { LocalizedString } from 'app/shared/model/localized-string.model';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';


@Injectable({
  providedIn: 'root',
})
export class ApplicationStateService {

  private collectionName = 'portail-state';

  constructor(private firestore: Firestore) { }

getMaintenanceState(): Observable<boolean> {
  const stateRef = doc(
    this.firestore,
    `${this.collectionName}/${this.collectionName}`
  );

  return docData(stateRef).pipe(
    map(data => (data as any)?.maintenance ?? false),
    catchError(error => this.handleError(error))
  );
}

getAnnualFormClosingDate(): Observable<string | null> {
  const stateRef = doc(
    this.firestore,
    `${this.collectionName}/${this.collectionName}`
  );

  return docData(stateRef).pipe(
    map(data => (data as any)?.annualFormClosingDate ?? null)
  );
}

getAnnualFormClosingMessage(): Observable<LocalizedString | null> {
  const stateRef = doc(
    this.firestore,
    `${this.collectionName}/${this.collectionName}`
  );

  return docData(stateRef).pipe(
    map(data => (data as any)?.annualformClosingMessage ?? null)
  );
}

  private handleError(error: string): Observable<boolean> {
    console.error(error);
    return of(false);
  }
}
